// Using public folder images
const heroImage1 = '/STORAGE1.webp';
const heroImage2 = '/PIPE1.webp';
const heroImage3 = '/scrubber.webp';
const heroImage4 = '/vessel.webp';

export interface Product {
  id: string;
  name: string;
  shortDescription: string;
  fullDescription: string;
  badge: string;
  certification: string;
  image: string;
  heroImage: string;
  images: string[];
  technicalSpecifications: { key: string; value: string }[];
  applications: string[];
  features: string[];
  certifications: string[];
  availability: string;
}

const PRODUCTS: Product[] = [
  {
    id: "pickling-acid-rec-tank",
    name: "Pickling Acid Rec. Tank",
    shortDescription:
      "High-grade FRP tanks for storing and recovering pickling acids. Widely used in Chemical and Steel industries.",
    fullDescription:
      "High-grade FRP tanks designed for storing and recovering pickling acids used in steel and chemical industries. Fabricated using hand lay-up or filament winding process with isophthalic or vinyl ester resin for superior corrosion resistance.",
    badge: "Storage Tank",
    certification: "ISO 9001",
    image: heroImage1,
    heroImage: heroImage1,
    images: [heroImage1, heroImage2],
    technicalSpecifications: [
      { key: "Capacity Range", value: "500L – 1,00,000L" },
      { key: "Material", value: "FRP / GRP" },
      { key: "Resin Type", value: "Isophthalic / Vinyl Ester" },
      { key: "Max Temperature", value: "Up to 80°C" },
      { key: "Orientation", value: "Vertical / Horizontal" },
      { key: "Surface Finish", value: "Gel coat / Natural" },
      { key: "Fitting", value: "HDPE / SS / FRP nozzles" },
      { key: "Pressure Rating", value: "Atmospheric / Up to 2.5 bar" },
    ],
    applications: [
      "Pickling acid storage in steel plants",
      "Chemical storage for acids and alkalis",
      "Process tanks in electroplating units",
      "Effluent holding tanks in ETP plants",
      "Pharmaceutical intermediate storage",
    ],
    features: [
      "Superior corrosion resistance to HCl, H2SO4, HNO3",
      "Hydraulically tested before dispatch",
      "Custom nozzle layout and dimensions",
      "UV stabilised exterior for outdoor use",
      "Long service life – 20+ years",
    ],
    certifications: ["ISO 9001:2015", "IS 12866"],
    availability: "Vapi, Gujarat – Pan India Supply",
  },
  {
    id: "pipes-and-fittings",
    name: "Pipes & Fittings",
    shortDescription:
      "Industrial FRP piping systems for corrosive liquid transfer. Advanced resin and composite materials.",
    fullDescription:
      "Industrial FRP piping systems for carrying corrosive liquids, acids, alkalis, and chemicals. Full range of fittings available.",
    badge: "Piping System",
    certification: "ISO 9001",
    image: heroImage2,
    heroImage: heroImage2,
    images: [heroImage2, heroImage3],
    technicalSpecifications: [
      { key: "Diameter Range", value: "DN 25 – DN 2000" },
      { key: "Pressure Rating", value: "Up to 10 bar" },
      { key: "Manufacture", value: "Filament winding / Hand lay-up" },
      { key: "Resin Type", value: "Isophthalic / Vinyl Ester" },
      { key: "Fittings", value: "Elbows, Tees, Reducers, Flanges" },
      { key: "Joint Type", value: "Bell & Spigot / Flanged" },
      { key: "Standard", value: "ASTM D2996 / ISO 14692" },
      { key: "Installation", value: "Above ground / Buried" },
    ],
    applications: [
      "Acid and alkali transfer lines",
      "Chemical plant process piping",
      "Effluent transfer in ETP plants",
      "Sea water intake piping",
      "Irrigation and water supply networks",
    ],
    features: [
      "Full range fittings available",
      "High pressure rating up to 10 bar",
      "Corrosion-resistant inside and outside",
      "Lightweight – easy handling",
      "Available in custom lengths",
    ],
    certifications: ["ISO 9001:2015", "ASTM D2996", "ISO 14692"],
    availability: "Vapi, Gujarat – Pan India Supply",
  },
  {
    id: "frp-pp-frp-ductings",
    name: "FRP / PP FRP Ductings",
    shortDescription:
      "Reliable FRP & GRP duct systems for corrosive fume extraction in chemical plants worldwide.",
    fullDescription:
      "FRP and PP-FRP duct systems for corrosive fume extraction and ventilation. Available in round, square, and rectangular sections.",
    badge: "Ducting System",
    certification: "ISO 9001",
    image: heroImage3,
    heroImage: heroImage3,
    images: [heroImage3, heroImage4],
    technicalSpecifications: [
      { key: "Diameter Range", value: "100mm – 2500mm" },
      { key: "Shape", value: "Round / Square / Rectangular" },
      { key: "Pressure Rating", value: "Up to 2500 Pa" },
      { key: "Material", value: "FRP / PP-FRP / GRP" },
      { key: "Fittings", value: "Bends, Tees, Dampers, Flanges" },
      { key: "Wall Thickness", value: "4mm – 12mm" },
      { key: "Jointing", value: "Flanged with gasket" },
      { key: "Surface", value: "Smooth inside for low friction" },
    ],
    applications: [
      "Fume extraction in pickling lines",
      "Acid fume ventilation in electroplating",
      "Chlorine gas handling",
      "Chemical plant exhaust systems",
      "Laboratory fume extraction",
    ],
    features: [
      "Custom cross-section and dimensions",
      "All fittings in matching material",
      "Smooth inside surface",
      "Leak tested before dispatch",
      "Flanged connections for easy assembly",
    ],
    certifications: ["ISO 9001:2015"],
    availability: "Vapi, Gujarat – Pan India and Export",
  },
  {
    id: "frp-scrubbers-and-stack",
    name: "FRP Scrubbers & Stack",
    shortDescription:
      "Complete FRP scrubber systems for acid fume removal and industrial emission control.",
    fullDescription:
      "Packed bed FRP scrubbers for removal of acid fumes, alkali vapours, and toxic gases. Custom designed for specific requirements.",
    badge: "Air Control",
    certification: "CPCB Compliant",
    image: heroImage4,
    heroImage: heroImage4,
    images: [heroImage4, heroImage1],
    technicalSpecifications: [
      { key: "Air Flow Range", value: "500 – 1,00,000 m³/hr" },
      { key: "Packing Media", value: "PP Pall rings / Saddles" },
      { key: "Removal Efficiency", value: ">98%" },
      { key: "Scrubbing Liquid", value: "Water / NaOH / H2SO4" },
      { key: "Stack Height", value: "5m – 40m" },
      { key: "Stack Diameter", value: "150mm – 2000mm" },
      { key: "Design Standard", value: "CPCB / IS 14845" },
      { key: "Body Material", value: "FRP / GRP" },
    ],
    applications: [
      "HCl fume scrubbing in pickling lines",
      "SO2 scrubbing in chemical plants",
      "NH3 scrubbing in fertiliser plants",
      "Chlorine gas scrubbing",
      "Acid mist control in electroplating",
    ],
    features: [
      "Complete system with pump and instrumentation",
      "Custom designed for target efficiency",
      "Mist eliminator included",
      "CPCB compliant",
      "FRP chimney stacks available",
    ],
    certifications: ["CPCB Compliant", "IS 14845", "ISO 9001:2015"],
    availability: "Vapi, Gujarat – Pan India Supply",
  },
  {
    id: "industrial-vessels",
    name: "Industrial Vessels",
    shortDescription:
      "Custom FRP process vessels for chemical reaction, mixing, and storage in corrosive environments.",
    fullDescription:
      "Custom-engineered FRP process vessels for chemical reaction, mixing, and storage. Open-top or closed-top configurations available.",
    badge: "Process Vessel",
    certification: "ASME RTP-1",
    image: heroImage1,
    heroImage: heroImage1,
    images: [heroImage1, heroImage3],
    technicalSpecifications: [
      { key: "Volume Range", value: "100L – 5,00,000L" },
      { key: "Operating Pressure", value: "Atmospheric to 6 bar" },
      { key: "Design Standard", value: "ASME RTP-1 / BS 4994" },
      { key: "Cover Type", value: "Open top / Closed top" },
      { key: "Agitator Provision", value: "Available" },
      { key: "Heating Coil Port", value: "Available" },
      { key: "Nozzle Layout", value: "Custom as per P&ID" },
      { key: "Material", value: "FRP / PP-FRP / HDPE lined" },
    ],
    applications: [
      "Chemical reaction vessels",
      "Mixing and blending vessels",
      "Electroplating process tanks",
      "Acid neutralisation vessels",
      "Industrial washing vessels",
    ],
    features: [
      "Custom nozzle layout from P&ID",
      "Agitator drive flange provisions",
      "Heating/cooling coil provisions",
      "Man-entry manhole",
      "ASME RTP-1 compliant",
    ],
    certifications: ["ASME RTP-1", "ISO 9001:2015", "BS 4994"],
    availability: "Vapi, Gujarat – Pan India Supply",
  },
  {
    id: "motor-cover-frp-gutter",
    name: "Motor Cover, FRP Gutter",
    shortDescription:
      "Protective FRP motor covers and acid-resistant gutter systems for chemical plants.",
    fullDescription:
      "Protective FRP motor covers for outdoor and corrosive environments. FRP gutter systems for acid drainage in pickling shops and electroplating plants.",
    badge: "Accessories",
    certification: "ISO 9001",
    image: heroImage2,
    heroImage: heroImage2,
    images: [heroImage2, heroImage4],
    technicalSpecifications: [
      { key: "Motor Cover", value: "Custom frame size" },
      { key: "Finish", value: "UV stabilised gel coat" },
      { key: "Vent Type", value: "Louvred / Mesh covered" },
      { key: "Gutter Width", value: "100mm – 600mm" },
      { key: "Gutter Depth", value: "100mm – 400mm" },
      { key: "Grating Cover", value: "FRP / GRP grating" },
      { key: "Colour", value: "Custom RAL / Standard grey" },
      { key: "Material", value: "FRP / GRP" },
    ],
    applications: [
      "Motor protection in chemical plants",
      "Acid drainage in pickling lines",
      "Effluent collection in electroplating",
      "Industrial floor drainage",
      "Outdoor motor protection",
    ],
    features: [
      "Custom dimensions and shape",
      "UV stabilised for outdoor use",
      "Acid-resistant surface",
      "Lightweight easy installation",
      "FRP grating cover available",
    ],
    certifications: ["ISO 9001:2015"],
    availability: "Vapi, Gujarat – Pan India Supply",
  },
];

export default PRODUCTS;

export function getProductById(id: string): Product | undefined {
  return PRODUCTS.find((p) => p.id === id);
}

export function getRelatedProducts(currentId: string, limit = 3): Product[] {
  return PRODUCTS.filter((p) => p.id !== currentId).slice(0, limit);
}